import { OfferModel } from '@/types'

export interface WizardStep1 {
  name: string
  status: OfferModel.Status
  type: OfferModel.OfferType | null
  starts_at: string
  ends_at: string
  min_order_value: number
  max_total_uses: number | null
  max_uses_per_customer: number | null
  coupon_allowed: boolean
  /** Where the offer applies: the online store, the tills, or both (server default `both`). */
  applies_to?: OfferModel.AppliesTo
  /** Till offers only: one branch, or null for every branch. */
  branch_id?: string | null
}

export interface WizardStep2 {
  offer_rules: Partial<OfferModel.OfferRules>
}

export interface WizardStep3 {
  ui_content: OfferModel.UiContent
}

export const validateStep = (
  step: 1 | 2 | 3,
  step1: WizardStep1,
  step2: WizardStep2,
): string[] => {
  const errors: string[] = []

  if (step === 1) {
    if (!step1.name.trim())   errors.push('Campaign name is required')
    if (!step1.type)           errors.push('Select an offer type to continue')
    if (!step1.starts_at)     errors.push('Start date is required')
    if (!step1.ends_at)       errors.push('End date is required')
    if (step1.starts_at && step1.ends_at && step1.starts_at >= step1.ends_at)
      errors.push('End date must be after start date')
  }

  if (step === 2) {
    const r = step2.offer_rules as any
    switch (step1.type) {
      case 'single_product':
        if (!r.product_id)     errors.push('Select a product')
        if (!r.discount_value) errors.push('Enter a discount value')
        break
      case 'buy_x_get_y':
        if (!r.buy_items?.length) errors.push('Add at least one "buy" item')
        if (!r.get_items?.length) errors.push('Add at least one "get" item')
        break
      case 'volume_discount':
        if (!r.product_id)      errors.push('Select a product')
        if (!r.tiers?.length)   errors.push('Add at least one discount tier')
        break
      case 'combo_fixed_price':
        if (!r.items?.length)   errors.push('Add at least two products to the bundle')
        if (!r.price)           errors.push('Enter the bundle price')
        break
    }
  }

  return errors
}
